var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./MyTrainingsModal.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5812f12a!../../node_modules/vue-loader/lib/selector?type=template&index=0!./MyTrainingsModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/MyTrainingsModal.vue
// module id = 685
// module chunks = 0